
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'
import voucherMixin from '@marketplace/mixins/voucherMixin.js'

export default {
    name: 'ModalVoucherPrompt',

    components: {
        ModalEducateUsers,
    },

    mixins: [voucherMixin],

    props: {
        voucherData: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            steps: [],
        }
    },

    watch: {
        voucherData: {
            immediate: true,
            deep: true,
            handler() {
                this.initializeSteps()
            },
        },
    },

    methods: {
        initializeSteps() {
            this.steps = [this.createVoucherStep(this.voucherData)].filter(
                Boolean
            )
        },
    },
}
